import { render, staticRenderFns } from "./LiabilitiesMortgages.vue?vue&type=template&id=44981151"
import script from "./LiabilitiesMortgages.vue?vue&type=script&lang=js"
export * from "./LiabilitiesMortgages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports